import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Padder = styled.div `
  margin-top: auto;
  padding: ${themeGet('spacing.xl')};
`;
